import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper, TablePagination } from '@material-ui/core';
import MaterialTable from 'material-table';
import { Button,Checkbox,Tabs,Tab, H4, H5, Dialog } from '@blueprintjs/core';
import CollocSpecPopup from './CollocSpecPopup.js';
import { rounded } from '../../../utils';
import { CsvBuilder } from "filefy";
import './CollocByCorpus.css';

class CollocByCorpus extends React.PureComponent {

  state = {
    isOpenModal:false,
    currentKey:"",    // the key to send to VocSpecPopup
    currentTab:'colloc',
    noUpperCase:false
  }

  vocSpecPopupColloc = (e) => {
    this.setState({currentKey:e.target.value, currentTab:'colloc'});
    this.toggleModal();
  }
  vocSpecPopupRel = (e) => {
    this.setState({currentKey:e.target.value, currentTab:'rel'});
    this.toggleModal();
  }
  toggleModal = () => {
    this.setState(prevState => ({ isOpenModal: !prevState.isOpenModal }));
  }
  calcQuery = (lem1,lem2) => {
    return "<l="+lem1+",#1>&&<l="+lem2+",#2>::(.*,1,2)";
  }



  render() {
    const { collocStats, relStats, name, t } = this.props;
    const { isOpenModal} = this.state;

    const displayRelStats=relStats && relStats.length>0;
    const displayCollocStats=collocStats && collocStats.length>0;
    let collocCols;
    let relCols;
    let dataCollocTable = [];
    let dataRelTable = [];
    if (name==='global') {
      if (displayCollocStats) {
        for (var i=0;i<collocStats.length;i++) {
          const row = {
            num: i+1,
            lem1: collocStats[i][0],
            lem2: collocStats[i][1],
            freq: collocStats[i][2],
            disp: collocStats[i][3],
            assoc: collocStats[i][4],
          };
          dataCollocTable.push(row);
        }

        collocCols=[
          { title: t('rank'), field:'num' },
          { title: t('lemma1'), 
            render: row => <Button minimal small onClick={()=> { this.props.performSearch({query:this.calcQuery(row.lem1,row.lem2)})} } >{row.lem1}</Button>,
            customFilterAndSearch: (term, rowData) => rowData.lem1.match(term),
            defaultFilter:this.state.noUpperCase? "^[^A-Z]":""
          },
          { title: t('lemma2'), 
            render: row => <Button minimal small onClick={()=> { this.props.performSearch({query:this.calcQuery(row.lem2,row.lem1)})} } >{row.lem2}</Button>,
            customFilterAndSearch: (term, rowData) => rowData.lem2.match(term),
            defaultFilter:this.state.noUpperCase? "^[^A-Z]":""
          },
          { title: t('frequency'), 
            customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.freq,
            field:'freq' 
          },
          { title: t('dispersion'), 
            customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.disp,
            field:'disp' 
          },
          { title: t('association')+" (PMI)" , 
            customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.assoc,
            field:'assoc'
          },
          { title: t('compare'), render: row => <button value={row.lem1+'\t'+row.lem2} onClick={this.vocSpecPopupColloc}>cmp</button> },
        ];
      }

      if (displayRelStats) {
        for (i=0;i<relStats.length;i++) {
          const row = {
            num: i+1,
            rel: relStats[i][0],
            freq: relStats[i][1],
          };
          dataRelTable.push(row);
        }

        relCols=[
          { title: t('rank'), field:'num' },
          { title: t('relation'), field:'rel'  },
          { title: t('frequency'), field:'freq' },
          { title: t('compare'), render: row => <button value={row.rel} onClick={this.vocSpecPopupRel}>cmp</button> },
        ];
      }
    } else {
      if (displayCollocStats) {
        for (i=0;i<collocStats.length;i++) {
          const row = {
            num: i+1,
            lem1: collocStats[i][0],
            lem2: collocStats[i][1],
            freq: collocStats[i][2],
            totFreq: collocStats[i][3],
            spec: rounded(collocStats[i][4],2),
            assoc: rounded(collocStats[i][5],2),
            mean: rounded(collocStats[i][6],2),
          };
          dataCollocTable.push(row);
        }

        // for corpus stats only
        collocCols=[
          { title: t('rank'), field:'num' },
          { title: t('lemma1'), 
            render: row => <Button minimal small onClick={()=> { this.props.performSearch({query:this.calcQuery(row.lem1,row.lem2)})} } >{row.lem1}</Button>,
            customFilterAndSearch: (term, rowData) => rowData.lem1.match(term),
            defaultFilter:this.state.noUpperCase? "^[^A-Z]":""
            
          },
          { title: t('lemma2'), 
            render: row => <Button minimal small onClick={()=> { this.props.performSearch({query:this.calcQuery(row.lem2,row.lem1)})} } >{row.lem2}</Button>,
            customFilterAndSearch: (term, rowData) => { try { return rowData.lem2.match(term)} catch (e) {console.log(e)}},
            defaultFilter:this.state.noUpperCase? "^[^A-Z]":""
          },
          { title: t('frequency'), 
            customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.freq,
            field:'freq' 
          },
          { title: t('totFreqSent'), 
            customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.totFreq,
            field:'totFreq' 
          },
          { title: t('specificity')+" (loglike)" , 
            customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.spec,
            field:'spec'
          },
          { title: t('association')+" (PMI)" , 
            customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.assoc,
            field:'assoc'
          },
          { title: t('meanAssocSpec') , 
            customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.mean,
            field:'mean'
          },
          { title: t('compare'), render: row => <button value={row.lem1+'\t'+row.lem2} onClick={this.vocSpecPopupColloc}>cmp</button> },
        ];
      } 
      if (displayRelStats) {
        for (i=0;i<relStats.length;i++) {
          const row = {
            num: i+1,
            rel: relStats[i][0],
            freq: relStats[i][1],
            totFreq: relStats[i][2],
            spec: relStats[i][3],
          };
          dataRelTable.push(row);
        }

        relCols=[
          { title: t('rank'), field:'num' },
          { title: t('relation'), field:'rel' },
          { title: t('frequency'), field:'freq' },
          { title: t('totFreqSent'), field:'totFreq' },
          { title: t('specificity'), field:'spec' },
          { title: t('compare'), render: row => <button value={row.rel} onClick={this.vocSpecPopupRel}>cmp</button> },
        ];
      }
    }
    const collocTable = displayCollocStats ? ( 
      <>

        <p>{t('clickedCollocIsTheHead')}</p>
        <Checkbox
            label={t("filterOutUpperCase")}
            name={"filterOutUpperCase"}
            onClick={(e) => this.setState({noUpperCase : ! this.state.noUpperCase})}
            checked={this.state.noUpperCase}
        />         
        <MaterialTable
          title={t('colloc')}        
          columns={collocCols}
          data={dataCollocTable}
          options={{
            filtering: true,
            search: true,
            sorting: true,
            exportButton: true,
            //exportFileName:`${name}_colloc`,
            exportAllData: true,
            padding: 'dense',
            pageSize:100,
            exportCsv: (columns, data) => {
              const fileName = name+"_colloc";
              const builder = new CsvBuilder(
                  fileName + ".csv"
              );
              builder
                  .setColumns(
                    name!=='global' ? 
                      ["rang","lemme1","lemme2","freq","totFreq","spec","assoc","mean"]:
                      ["rang","lemme1","lemme2","freq","disp","assoc"]
                  )
                  .setDelimeter(this.props.csvDelimiter).addRows(
                    data.map((rowData) =>
                        name!=='global' ? [
                          rowData.num,
                          rowData.lem1,
                          rowData.lem2,
                          rowData.freq,
                          rowData.totFreq,
                          rowData.spec,
                          rowData.assoc,
                          rowData.mean,

                        ]:
                        [
                          rowData.num,
                          rowData.lem1,
                          rowData.lem2,
                          rowData.freq,
                          rowData.disp,
                          rowData.assoc,
                        ]

                      )
                  )
                  .exportFile();
            }

          }}
          components={{
            Pagination: props => (
              <TablePagination
                {...props}
                rowsPerPageOptions={[10,100,1000,dataCollocTable.length]}
              />
            ),
            Container: props => (
              <Paper
                {...props}
                elevation={0}
                className='straight'
              />
            ),
          }}
        />
      </>
    ):null;

    const relTable = displayRelStats ? (
        <MaterialTable
          title={t('relation')}
          columns={relCols}
          data={dataRelTable}
          options={{
            search: true,
            sorting: true,
            exportButton: true,
            //exportFileName:`${name}_pos`,
            exportAllData: true,
            pageSize:100,
            padding:'dense',
            exportCsv: (columns, data) => {
              const fileName = name+"_deprel";
              const builder = new CsvBuilder(
                  fileName + ".csv"
              );
              builder
                  .setColumns(
                      name!=='global'? 
                        ["rank","deprel","freq","totFreq","spec"]:
                        ["rank","deprel","freq"]
                  )
                  .setDelimeter(this.props.csvDelimiter).addRows(
                    data.map((rowData) =>
                      name!=='global'? [
                          rowData.num,
                          rowData.rel,
                          rowData.freq,
                          rowData.totFreq,
                          rowData.spec
                        ]:
                        [
                          rowData.num,
                          rowData.rel,
                          rowData.freq,
                        ]
                      )
                  )
                  .exportFile();
            },

          }}
          components={{
            Pagination: props => (
              <TablePagination
                {...props}
                rowsPerPageOptions={[10,100,1000,dataRelTable.length]}
              />
            ),
            Container: props => (
              <Paper
                {...props}
                elevation={0}
                className='straight'
              />
            ),
          }}
        />
    ):null;
    
    return(
      <>
        <Paper className="margin-bottom-1-rem padding-1-rem">
          { this.props.displayShortName &&
            <H5>{t('name')} : {this.props.name}</H5>
          }

          <H4>{name==='global'?t('globalCollocCollig'):t('specificCollocCollig')}</H4>

        </Paper>
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
          { displayCollocStats && 
            <Tab key='colloc' id='colloc' title={name==='global'? t('globalColloc'):t('specificColloc')} panel={collocTable} />
          }
          { displayRelStats && 
            <Tab key='rel' id='rel' title={name==='global'? t('globalRel'):t('specificRel')} panel={relTable} />
          }
        </Tabs>

        <Dialog
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            title={t('vocSpecComparison')}
            style={{'width': '800px'}}  // 800px seems a good deal
        >
          <CollocSpecPopup entry={this.state.currentKey} data={this.props.spec[this.state.currentTab][this.state.currentKey]}/>
        </Dialog>
        
      </>
    );
  }

}

CollocByCorpus.propTypes = {
  name: PropTypes.string,
  displayShortName:PropTypes.bool,
  collocStats: PropTypes.array,
  relStats: PropTypes.array,
  spec: PropTypes.object,
  performSearch: PropTypes.func,
  csvDelimiter: PropTypes.string, 
};

export default withTranslation()(CollocByCorpus);
